import Alert from "../components/alert-component/AlertComponent.js"

export default {
	data() {
		return {
			clientKey: process.env.VUE_APP_MIDTRANS_CLIENT_KEY,
			mindtransUrl: process.env.VUE_APP_MIDTRANS_URL,
			snap: null,

			scriptTag: null
		}
	},

	created() {
		console.log('MIDTRANS MIXIN CREATED')
		window.onbeforeunload = null
		const elementSnapMidtrans = document.getElementById('snap-midtrans')
		if (elementSnapMidtrans) {
			elementSnapMidtrans.remove()
		}
	},

	mounted() {

	},

	beforeDestroy() {

	},

	methods: {
		midtransSnapInit() {
			return new Promise((resolve) => {
				if (this.getMidtransSnap) {
					// alert('already-loaded')
					return
				}
				const midtransUrl = this.mindtransUrl + '/snap/snap.js'
				this.scriptTag = document.createElement('script')
				const midtransClientKey = this.clientKey
				this.scriptTag.src = midtransUrl
				this.scriptTag.setAttribute('data-client-key', midtransClientKey)
				this.scriptTag.async = true

				document.body.appendChild(this.scriptTag)

				this.scriptTag.onload = () => {
					this.snap = window.snap
					resolve()
				}
			})
		},

		async payMidtrans(snapToken) {
			Alert.open({
				type: 'loading',
			})

			// close loading after modal payment open
			const intervalCheck = setInterval(() => {
				const modalPayment = document.getElementById('snap-midtrans')
				if (modalPayment.style.display == 'block') {
					clearInterval(intervalCheck)
					Alert.close()
				}
			}, 1000)
			
			// if snap script not loaded, load
			if (!this.snap) {
				await this.midtransSnapInit()
			}

			return new Promise((resolve, reject) => {
				window.snap.pay(snapToken, {
					uiMode: "deeplink",
					onSuccess: (result) => {
						console.log('MIDTRANS PAY ON SUCCESS')
						window.onbeforeunload = null

						resolve(result)
					},
					onPending: (result) => {
						console.log('MIDTRANS PAY ON PENDING')
					},
					onError: (result) => {
						console.log('MIDTRANS PAY ON ERROR')
						window.onbeforeunload = null

						reject({
							...result,
							message: 'error'
						})
					},
					onClose: () => {
						console.log('MIDTRANS PAY ON CLOSE')

						this.scriptTag.remove()

						reject({ message: 'closed' })
					}
				})
			})
		}
	}
}